/**
 * Study Anything: the user's own uploaded books (backend apps/study), and the
 * book tutor rewired to one of them. Keyed by the book's id.
 */

import api from "../../api";

const BOOKS = "api/study/books";
const TUTOR = (bookId) => `${BOOKS}/${bookId}/tutor`;

export { errorMessage } from "../ContentBank/contentBankApi";

/** [{id, title, pages, size_bytes, lines, uploaded_at, lesson_id}] */
export const listBooks = async () => (await api.get(`${BOOKS}/`)).data.books;

/** A Markdown file (and an optional title) → the book row. */
export const uploadBook = async (file, title = "") => {
  const form = new FormData();
  form.append("file", file);
  if (title.trim()) form.append("title", title.trim());
  return (await api.post(`${BOOKS}/`, form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};

/** The row, with `content_url` (signed, an hour). */
export const getBook = async (bookId) => (await api.get(`${BOOKS}/${bookId}/`)).data;

/** The Markdown itself. */
export const getBookContent = async (bookId) =>
  (await api.get(`${BOOKS}/${bookId}/content/`, { responseType: "text", transformResponse: [(d) => d] })).data;

export const deleteBook = async (bookId) => (await api.delete(`${BOOKS}/${bookId}/`)).data;

// ─── The tutor (same shape as booksApi) ─────────────────────────────────────

/** { message, request_id, images?, section?, context_text? } */
export const askStudy = async (bookId, body) => (await api.post(`${TUTOR(bookId)}/chat/`, body)).data;

export const getStudyJob = async (bookId, job) =>
  (await api.get(`${TUTOR(bookId)}/chat/jobs/${encodeURIComponent(job)}/`)).data;

/** { messages: [{role, content, timestamp, i, context, sources}], has_more, offline?, not_ready? } */
export const getStudyHistory = async (bookId, before = null, limit = 100) =>
  (await api.get(`${TUTOR(bookId)}/chat/`, { params: { limit, ...(before !== null ? { before } : {}) } })).data;

export const clearStudy = async (bookId) => (await api.delete(`${TUTOR(bookId)}/chat/`)).data;

/** { online, queued, can_review: false } */
export const getStudyStatus = async (bookId) => (await api.get(`${TUTOR(bookId)}/status/`)).data;

// Side conversations: tabs branched from a passage (backend sessions/threads.py).

export const getStudyThreads = async (bookId) => (await api.get(`${TUTOR(bookId)}/threads/`)).data.threads;
export const createStudyThread = async (bookId, body) => (await api.post(`${TUTOR(bookId)}/threads/`, body)).data;
export const updateStudyThread = async (bookId, threadId, patch) =>
  (await api.patch(`${TUTOR(bookId)}/threads/${threadId}/`, patch)).data;
export const askStudyThread = async (bookId, threadId, body) =>
  (await api.post(`${TUTOR(bookId)}/threads/${threadId}/chat/`, body)).data;
export const getStudyThreadHistory = async (bookId, threadId, before = null, limit = 100) =>
  (await api.get(`${TUTOR(bookId)}/threads/${threadId}/chat/`, { params: before === null ? { limit } : { before, limit } })).data;
